/*******************************************************************************
 * Copyright     : Copyright (c)  2020 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : SoftwareFeaturesItemRadioGroup.tsx
 *
 * Project Title : RDR7000
 *
 * Description   : Software Features Item Custom Radio Group component
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Amol Jagtap (H409453)
 *
 * @Date         : Aug 15, 2020
 *
 * @Version      : Version 1.0
 *
 * By            : Amol Jagtap (H409453)
 * On            : Aug 15, 2020
 * Description   : Create custom component for Radio Group to be used in Software Features accordion
 *
 *
 ******************************************************************************/

import React, { FC } from 'react';
import capitalize from 'lodash/capitalize';
import { Radio, InputLabel } from '@scuf/common';
import { ISoftwareFeaturesRadioProps } from './ISoftwareFeaturesItemProps';

export const SoftwareFeaturesItemRadioGroup: FC<ISoftwareFeaturesRadioProps> = ({
  name,
  label,
  value,
  dataset,
  disabled,
  onChange,
}) => (
  <>
    <InputLabel label={label} />
    {dataset.map(item => (
      <Radio
        key={item}
        name={name}
        label={capitalize(item)}
        checked={value === item}
        disabled={disabled}
        onChange={() => onChange(name, item)}
      />
    ))}
  </>
);
